module.exports = __webpack_public_path__ + "img/03_tu.e1b0b70d.png";